<mat-form-field appearance="standard">
  <mat-label>{{ label }}</mat-label>
  <lib-autocomplete
    #auto="autocomplete"
    [search]="search"
    (optionSelected)="onOptionSelected($event)"
    (cleared)="onCleared($event)"
  >
    <input
      matInput
      [required]="true"
      [placeholder]="placeholder"
      [formControl]="control"
      [matAutocomplete]="auto.autocomplete"
    />
    <ng-template let-firm let-highlight="highlight">
      <lib-lookup-option [item]="firm" [highlight]="highlight" [showStatus]="true"></lib-lookup-option>
    </ng-template>
  </lib-autocomplete>
  <button type="button" mat-icon-button matSuffix>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
</mat-form-field>
